import { cn } from '@/lib/utils';

interface LoadingSpinnerProps {
  className?: string;
  size?: 'sm' | 'md' | 'lg';
  fullScreen?: boolean;
}

function LoadingSpinner({ 
  className,
  size = 'md',
  fullScreen = false
}: LoadingSpinnerProps) {
  const sizeClasses = {
    sm: 'w-4 h-4',
    md: 'w-8 h-8',
    lg: 'w-12 h-12'
  };

  if (fullScreen) {
    return (
      <div className="flex flex-col h-screen bg-gray-50 dark:bg-gray-900">
        {/* Skeleton navbar preserving page structure */}
        <div className="h-16 flex-shrink-0 border-b border-gray-200/50 dark:border-gray-700/50" />
        <div className="flex-1 flex items-center justify-center">
          <div className={cn(
            'animate-spin rounded-full border-t-2 border-b-2 border-[#F37022]',
            sizeClasses[size],
            className
          )}></div>
        </div>
      </div>
    );
  }

  return (
    <div className="flex justify-center items-center">
      <div className={cn(
        'animate-spin rounded-full border-t-2 border-b-2 border-[#F37022]',
        sizeClasses[size],
        className
      )}></div>
    </div>
  );
}

export default LoadingSpinner;
export { LoadingSpinner };